<script>
  export let content
</script>

{content}
